export default __webpack_public_path__ + "static/media/11AW2NOV65.0e5d354c.jpg";